<ion-content scrollY="true">
  <div *ngIf="comments else loading">
    <div *ngIf="comments.length==0">{{"boulder-comments-component.no-comment-yet" | translate}}</div>
    <message *ngFor="let comment of comments| newestFirst"
             [showDeleteButton]="comment.author===authService.getCurrentUsername()"
             (onDelete)="deleteComment(comment.id)"
             [date]="comment.date" [text]="comment.comment" [author]="comment.author"></message>
  </div>
</ion-content>
<ion-footer>
  <form *ngIf="formGroup" [formGroup]="formGroup">
    <ion-item class="input-field">
      <ion-input [formControl]="comment" inputmode="text" aria-label='comment' class="comment"
                 placeholder='{{"boulder-comments-component.write-a-comment" | translate}}'
                 type="text"></ion-input>
      <ion-button (click)="sendComment()" [disabled]="comment.value=='' || !comment.valid" color="primary" size="big"
                  slot="end" shape="round">
        <ion-icon name="send"></ion-icon>
      </ion-button>
    </ion-item>
  </form>
</ion-footer>
<ng-template #loading>
  {{"boulder-comments-component.loading" | translate}}
</ng-template>
